/**
 * Angular Root Component
 *
 * This is a minimal root component for the Angular side of the hybrid app.
 * The actual UI is still rendered by AngularJS during the migration.
 *
 * As views are migrated to Angular, they will be rendered through
 * Angular's router within this component.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'ng-app-root',
  standalone: false,
  template: `
    <!-- 
      During hybrid mode, AngularJS handles the main UI.
      Angular components are embedded within AngularJS templates.
      
      Once migration is complete, this will contain:
      <router-outlet></router-outlet>
    -->
    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class AppComponent {
  title = 'ACME B2B';
}

